import React, { useEffect, useState } from "react";
import {
  Spin,
  Button,
  Row,
  Space,
  Card,
  Table,
  Typography,
  Form,
  Modal,
  Tooltip,
  Input,
} from "antd";
import { ArrowRight, CircleAlert, GitFork, Search } from "lucide-react";

import { BRANCH_STORAGE, FONT } from "constants/index";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import { Columns } from "./columns-table";
import DrawerApp from "components/drawer-app";
import BranchCreateClient from "./branches-create-client";
import {
  deleteBranch,
  findAllBranches,
  putBranch,
  saveBranch,
} from "services/branch/branch-service";
import { useNavigate } from "react-router-dom";
import BranchStats from "./branches-stats";

const { Text } = Typography;
const { confirm } = Modal;

const BranchClient = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    refreshData();
  }, []);

  const refreshData = async () => {
    setLoading(true);
    try {
      let obj = {
        search: search,
      };

      if (search == null || search == "") {
        obj = {};
      }
      const data = await findAllBranches(obj);
      const branches = data.map((item) => {
        return {
          ...item,
          edit,
          delete: disable,
          changeBranch: changeBranch,
        };
      });
      setData(branches);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };
  const handleOk = async () => {
    setLoading(true);

    try {
      const values = await form.validateFields();
      const funcSave = editId !== null ? putBranch : saveBranch;
      await funcSave(editId, values);
      notificationSucess();
      onClose();
      refreshData();
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setTimeout(() => {
      form.resetFields();
    }, 0);
    setEditId(null);
    setOpen(false);
  };
  function edit(row) {
    setEditId(row.id);
    setTimeout(() => {
      form.setFieldsValue({
        role: row.role,
        name: row.name,
        owner: row.owner,
        evoUser: row.evoUser,
        evoPass: row.evoPass,
        hasPhotocell: row.hasPhotocell,
        webhooks: row.webhooks
      });
    }, 0);
    showDrawer();
  }
  function disable(row) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Tem certeza que deseja deletar a unidade '{row.name}' ?
          </span>
        </div>
      ),
      icon: null,
      okText: "Sim",
      okType: "danger",
      cancelText: "Não",
      onOk() {
        setLoading(true);
        deleteBranch(row.id)
          .then(() => {
            notificationSucess();
            refreshData();
          })
          .catch((err) => {
            setLoading(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {},
    });
  }

  const changeBranch = (row) => {
    localStorage.setItem(
      BRANCH_STORAGE,
      JSON.stringify({
        id: row.id,
        name: row.name,
        type: row.role,
        hasPhotocell: row.hasPhotocell

      })
    );
    navigate("/app/client/managerial");
  };
  return (
    <div className="container-branches-client">
      <Spin size="large" spinning={loading}>
        <BranchStats values={data} />
        <Row gutter={24} style={{ padding: "10px" }}>
          <Space>
            <Input
              placeholder="Pesquisar Unidade"
              onChange={(value) => setSearch(value.target.value)}
              suffix={<Search size={18} color="#e0e0e0" />}
              style={{ height: "40px" }}
              onPressEnter={refreshData}
            />

            <Button
              style={{ fontFamily: FONT }}
              type="primary"
              icon={
                <ArrowRight
                  size={18}
                  style={{ marginBottom: "-3px", marginRight: "7px" }}
                />
              }
              onClick={refreshData}
            >
              Filtrar
            </Button>
          </Space>
        </Row>
        <Row gutter={[24, 24]} style={{ marginLeft: "0px" }}>
          <Space
            direction="vertical"
            size={"small"}
            style={{
              flex: "1 1 500px",
              minWidth: outerWidth < 501 ? "0px" : "500px",
            }}
          >
            <Card
              id="card-table"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <GitFork
                      size={18}
                      style={{ marginBottom: "-4px", marginRight: "10px" }}
                    />
                    <Text style={{ fontSize: "15px", fontFamily: FONT }}>
                      Unidades
                    </Text>
                  </div>
                  {/*<Button
                    onClick={showDrawer}
                    style={{ fontFamily: FONT, marginLeft: "10px" }}
                  >
                    <Tooltip style={{ fontFamily: FONT }} title="Nova Unidade">
                      <UserRoundPlus size={20} />
                    </Tooltip>
                  </Button>
                  */}
                </div>
              }
              bordered={false}
            >
              <Table
                columns={Columns(outerWidth)}
                dataSource={data}
                pagination={{ pageSize: 10, showSizeChanger: false }}
                locale={{
                  emptyText: "Sem registro",
                }}
              />
            </Card>
          </Space>
        </Row>
      </Spin>

      <DrawerApp
        open={open}
        onClose={onClose}
        title={"Nova Unidade"}
        body={<BranchCreateClient form={form} />}
        size={outerWidth < 501 ? "small" : "large"}
        actionSave={handleOk}
      />
    </div>
  );
};
export default BranchClient;
